export default "__VITE_ASSET__LcoUupma__"